export const LANGUAGE_STORAGE_KEY = 'app_language';

/**
 * Resolve saved language. Prefer explicit app key, then keys used by i18n sync.
 * Default: English (matches site default when nothing is stored).
 */
export const getLanguageFromStorage = (): string => {
  try {
    const fromApp = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    const fromShared = localStorage.getItem('shared_app_language');
    const fromLegacy = localStorage.getItem('selectedLanguage');
    const storedLanguage = fromApp || fromShared || fromLegacy;
    return storedLanguage || 'en';
  } catch (error) {
    console.warn('Failed to get language from localStorage:', error);
    return 'en';
  }
};

export const setLanguageInStorage = (language: string): void => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch (error) {
    console.warn('Failed to save language to localStorage:', error);
  }
};

/**
 * Logout (manual, forced, session-timeout, or cross-app) wipes storage with a
 * blanket localStorage.clear()/sessionStorage.clear(), which also erased the
 * user's chosen display language — so every sign-out dropped back to whatever
 * the browser/OS locale detects. Call this instead of the raw clear() pair so
 * the language preference survives; every other key is still wiped as before.
 */
export const clearAppStorage = (): void => {
  let savedLanguage: string | null = null;
  try {
    savedLanguage =
      localStorage.getItem(LANGUAGE_STORAGE_KEY) ||
      localStorage.getItem('shared_app_language') ||
      localStorage.getItem('selectedLanguage');
  } catch {
    /* ignore */
  }
  try {
    localStorage.clear();
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* ignore */
  }
  if (savedLanguage) {
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, savedLanguage);
    } catch {
      /* ignore */
    }
  }
};